import { motion } from "framer-motion";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

interface BackButtonProps {
  id?: string;
  onBack: () => void;
  label?: string;
  className?: string;
}

export function BackButton({ id, onBack, label = "Back", className }: BackButtonProps) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -20, scale: 0.95 }}
      animate={{ opacity: 1, x: 0, scale: 1 }}
      exit={{ opacity: 0, x: -20, scale: 0.95 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
    >
      <Button
        id={id}
        variant="ghost"
        size="sm"
        onClick={onBack}
        className={`h-8 px-2 gap-1 hover:bg-accent ${className}`}
      >
        <ChevronLeft className="w-4 h-4" />
        <span className="hidden sm:inline">{label}</span>
      </Button>
    </motion.div>
  );
}
